import { useContext } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { AppBar, Box } from "@mui/material";
import { GlobalContext } from "../Context";
import MobileNavBar from "../MobileNavBar/MobileNavBar";
import UserAvatarButton from "../UserAvatarButton";
import { HOME_PATH } from "../../../constants";
import { green, purple } from "../../../theme/colours";

const Header = ({ isLoggedIn }) => {
  const {
    mobileView,
    tabletView,
    desktopView,
    firebaseState,
    setOptionState,
    userState,
    notFound,
  } = useContext(GlobalContext);
  const history = useHistory();

  const headerItemsCondition =
    userState.fn && (tabletView || mobileView) && !notFound;

  const headerStyle = {
    zIndex: (theme) => theme.zIndex.drawer + 1,
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: tabletView ? "6rem" : "4.5rem",
    pl: !headerItemsCondition && "2rem",
    justifyContent: "space-between",
    alignItems: tabletView ? "flex-end" : "center",
    background: `linear-gradient(90deg, ${green[3]} 0%, ${purple[2]} 100%)`,
    boxShadow: "none",
  };

  const logoStyle = {
    height: "100%",
  };

  const linkStyle = {
    height: "100%",
    padding: mobileView ? "0.75rem" : tabletView ? "1rem" : "0.5rem",
    ...(!desktopView && {
      position: "absolute",
      transform: "translate(-50%, 0)",
      left: "50%",
    }),
  };

  const handleLogout = () => {
    firebaseState.doSignOut();
    history.push(HOME_PATH);
  };

  const handleLogoClick = () => {
    setOptionState({ nav: "dashboard", page: "main" });
  };

  return (
    <AppBar position="fixed" sx={headerStyle} enableColorOnDark>
      {headerItemsCondition && <MobileNavBar />}
      {isLoggedIn && (
        <NavLink to={HOME_PATH} style={linkStyle}>
          <Box
            component="img"
            alt="Safe Roads Logo"
            src={"/images/safeRoads/SRC-NewLogo.webp"}
            onClick={handleLogoClick}
            sx={logoStyle}
          />
        </NavLink>
      )}
      {userState.authUser?.uid && !notFound && (
        <UserAvatarButton
          handleLogout={handleLogout}
          isAdmin={userState.isAdmin}
          isMedidas={userState.isMedidas}
          name={userState.fn}
          avatar={userState.avatar}
        />
      )}
    </AppBar>
  );
};

export default Header;
